define('pages/dashboard/DashboardController',[
	'jquery',
	'core/can',
	'models/Session',
	'models/Eft',
	'models/ClaimCount',
	'models/EligibilityIssues',
	'models/Claim',
	'models/Report',
	'highcharts',
	'moment',
	'template!pages/dashboard/DashboardView.stache',
	'template!pages/dashboard/ClaimCountSummaryView.stache',
	'template!pages/dashboard/ClaimIssuesView.stache',
	'template!pages/dashboard/EftChartView.stache',
	'template!pages/dashboard/EligibilityIssuesView.stache',
	'template!pages/dashboard/RapCancelRateView.stache',
	'template!pages/dashboard/TimelyFilingView.stache',
	'jquery-throttle'
], function ($, can, Session, Check, ClaimCount, EligibilityIssues, Claim, Report, Highcharts, moment, template) {

	var colors = Highcharts.getOptions().colors,
		formatter = Highcharts.Axis.prototype.defaultYAxisOptions.stackLabels.formatter;

	return can.Control.extend({

		init: function (el) {

			App.loading(false);

			var me = this,
				scope = this.scope = new (can.Map.extend({
					params: Session.filterParams(),
					showEftReport: App.isActionAllowed('EftsReport'),
					showClaimsReport: App.isActionAllowed('ClaimsReport'),
					showEligibilityReport: App.isActionAllowed('EligibilityReport'),
					isAllAccountsView: App.isAllAccountsView,
					providersList: Session.getProvidersList(),
					define: {
						expandEft: {
							get: function () {
								return this.attr('isAllAccountsView') || !this.attr('showClaimsReport');
							}
						}
					}
				}))();
			
			scope.attr('params').bind('change', can.$.debounce(100, fetch));
			el.html(can.view(template, scope));
			el.find("#Reports__AsideMenu").find('.collapse').collapse('show');

			fetch();

			function fetch() {
				var params = scope.attr('params').attr();
				
				if (scope.attr('showEftReport')) {
					Check.findAllWithProjected(can.extend({ StartDate: moment().startOf('week').format() }, params), function (r) {
						scope.attr('Checks', r);
						me.renderEftChart(el.find('#Dashboard__EFT .chart').get(0), r);
					})
				}
				if (scope.attr('showClaimsReport')) {
					var claimParams = {};
					if(Session._isVendor()){
						var providerList = [];
						var providers = scope.attr('providersList').attr();
						for(var i=0; i < providers.length; i++){
							providerList.push(providers[i].EntityId);
						}
						claimParams.providerList = JSON.stringify(providerList);
					}
					claimParams = Object.assign(claimParams, params);
					ClaimCount.findAll(claimParams, function (r) {
						scope.attr('ClaimCount', r);
						me.renderClaimCountChart(el.find('#Dashboard__ClaimCount .chart').get(0), r);
					});

					if (!scope.attr('isAllAccountsView')) {
						Report.getCancellationRate(params, function (r) {
							scope.attr('CancellationRate', r);
						});
					}

					Report.getTimelyFilingCount(params, function (r) {
						scope.attr(r.attr());
					});
					Report.getClaimCount(can.extend({ MedicareStatus: 'RTP', Status: '3' }, params), function (r) {
						scope.attr('RtpCount', r.Count);
					});
					Report.getClaimCount(can.extend({ MedicareStatus: 'RTPCanceled', Status: '3' }, params), function (r) {
						scope.attr('RtpCanceledCount', r.Count);
					});
					Report.getClaimCount(can.extend({ MedicareStatus: 'ADR' }, params), function (r) {
						scope.attr('AdrCount', r.Count);
					});
					Report.getClaimCount(can.extend({ MedicareStatus: 'Rejected' }, params), function (r) {
						scope.attr('RejectedCount', r.Count);
					});
					Report.getStuckInSuspenseCount(params, function (r) {
						scope.attr('StuckInSuspenseCount', r.Count);
					});
				}
				if (scope.attr('showEligibilityReport')) {
					EligibilityIssues.withCount(params, function (r) {
						scope.attr('EligibilityIssues', r);
					});
				}

				App.loading(false);
			}
		},

		renderEftChart: function (el, list) {

			if (this.EftChart) {
				this.EftChart.destroy();
				this.EftChart = undefined;
				$(el).empty();
			}

			if (list.attr('length')) {
				var options = Check.chartOptions();
				options.chart.renderTo = el;
				options.chart.height = 220;
				options.series = list.seriesDataByProjected();
				this.EftChart = new Highcharts.Chart(options);
			}
		},

		renderClaimCountChart: function (el, list) {

			if (this.ClaimCountChart) {
				this.ClaimCountChart.destroy();
				this.ClaimCountChart = undefined;
				$(el).empty();
			}

			if (list.attr('length')) {
				this.ClaimCountChart = new Highcharts.Chart({
					chart: {
						renderTo: el,
						plotBackgroundColor: null,
						plotBorderWidth: null,
						plotShadow: false,
						height: 220
					},
					title: {
						text: null
					},
					tooltip: {
						enabled: false
					},
					plotOptions: {
						pie: {
							allowPointSelect: true,
							cursor: 'pointer',
							dataLabels: {
								enabled: true,
								format: '{point.name} <b>{point.percentage:.1f}%</b>',
								style: {
									color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
								}
							},
							showInLegend: false
						},

						series: {
							cursor: 'pointer',
							point: {
								events: {
									click: function () {
										can.route.attr({
											page: 'reports',
											report: 'claimcount',
											statuscode: this.StatusCode,
											locationcode: this.LocationCode
										}, true);
									}
								}
							}
						}

					},
					series: [{
						type: 'pie',
						data: list.seriesData()
					}]
				});
			}
		},

		'#Dashboard__ClaimCount tbody tr mouseenter': (function () {

			var timer;

			return function (el) {
				var index = el.data('index'),
					chart = this.ClaimCountChart,
					data = chart.series[0].data;

				//chart.tooltip.hide();
				for (var i = 0; i < data.length; i++) {
					data[i].setState();
				}

				data[index].setState('hover');
				//chart.tooltip.refresh(data[index]);

				clearTimeout(timer);
				timer = setTimeout(function () {
					data[index].setState();
					//chart.tooltip.hide();
				}, 1500);
			}
		})(),

		/**
		 * Click event for rap suppress help.
		 * Opens app updates modal.
		 * @listens ClickEvent <button class="rap-suppress-help">
		 * @param {HTMLElement} el 
		 * @param {Event} ev 
		 * @returns 
		 */
		'.rap-suppress-help click': function (el, ev) {
			App.loadModal('modals/updates/UpdatesModal');
		}
	});
});










